<template>
  <div>
    <BaseMontadoras />

    <div>
      <div class="maquinas margin-row">
        <b-row>
          <b-col class="titulo-centralizado">
            <hr class="linha-titulo" />
            <h2 class="titulo"><strong>AS </strong> MÁQUINAS</h2>
            <hr class="linha-titulo" />
          </b-col>
        </b-row>
      </div>

      <div class="bg-maquinas"></div>
    </div>
  </div>
</template>

<script>
import { api } from "@/services.js";
import BaseMontadoras from "@/components/BaseMontadoras.vue";
export default {
  data() {
    return {
      slide: 0,
      sliding: null,
      maquinas: [],
    };
  },

  components: {
    BaseMontadoras,
  },

  methods: {
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
    fetchMaquinas() {
      this.loading = true;
      api
        .get("/Maquina")
        .then((resp) => {
          this.maquinas = resp.data.maquinas;
        })
        .catch((error) => console.log(error))
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.fetchMaquinas();
  },
};
</script>

<style scoped>
.maquinas {
  margin-bottom: 50px;
}

.bg-maquinas .carousel {
  top: 200px;
}

.img-carrossel {
  text-align: left;
  margin-bottom: 10px;
  margin-top: 10px;
}
@media (min-width: 991px) and (max-width: 1499px) {
  .maquinas {
    margin-top: -150px;
  }
}

@media (min-width: 1500px) {
  .maquinas {
    margin-top: -250px;
  }
}
</style>
